import API from "../Common/Endpoint/serviceConstrants";
import axiosInstanceClient from '../Common/Axios/axiosInstanceClient'
export const offerMasterApi = async () => {
  const { data = {} } = await axiosInstanceClient.get(API.getofferMaster);
  return data;
};
